import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

export type ButtonVariant = 'primary' | 'secondary' | 'tertiary' | 'text-underline';
export type ButtonSize = 'default' | 'small';

@Component({
  selector: 'custom-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './custom-button.component.html',
  styleUrl: './custom-button.component.scss'
})
export class CustomButtonComponent {
  @Input() text: string = '';
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'default';
  @Input() disabled: boolean = false;
  @Input() iconLeft: string = '';
  @Input() iconRight: string = '';
  @Input() customColor: string = '';
  @Input() customBackground: string = '';
  @Input() type: 'button' | 'submit' | 'reset' = 'submit';
  @Output() clicked = new EventEmitter<void>();

  get buttonClasses(): string {
    const classes: string[] = [];
    
    // Add variant class
    classes.push(`custom-button--${this.variant}`);
    
    // Add size class
    if (this.size === 'small') {
      classes.push('custom-button--small');
    }
    
    return classes.join(' ');
  }

  get buttonStyles(): { [key: string]: string } {
    const styles: { [key: string]: string } = {};
    
    if (this.customColor) {
      styles['--custom-button-color'] = this.customColor;
    }
    
    if (this.customBackground) {
      styles['--custom-button-background'] = this.customBackground;
    }
    
    return styles;
  }

  get hasIcon(): boolean {
    return !!(this.iconLeft || this.iconRight);
  }

  onClick(): void {
    if (this.disabled) {
      return;
    }
    this.clicked.emit();
  }
}
